import { dbEvents, dbFeedback } from 'dbServer/collections';
import { size as _size } from 'lodash-es';
import { SESSION_STATUS } from 'store/constants';

export const mapSessionModel = session => {
	const date = new Date(session.eventDateTime);

	return {
		...session,
		startedAt: date
		// finishedAt: addMinutes(date.getTime(), event.durationMins)
	};
};

export const fetchSessions = async () => {
	const sessions = await dbEvents.getSessions();
	return !_size(sessions) ? [] : sessions;
};

export const addSession = async newEvent => {
	newEvent.status = SESSION_STATUS.DRAFT;
	const addedSession = await dbEvents.addSession(newEvent);
	return addedSession;
};

export const updateSession = async (eventId, event) => {
	event.modifiedDate = new Date().toUTCString();
	const updatedSession = await dbEvents.updateSession(eventId, event);
	return updatedSession;
};

export const fetchSessionDetails = async eventId => {
	const sessionDetails = await dbEvents.getSessionDetails(eventId);
	return sessionDetails || {};
};

export const fetchSessionFeedbackQuestions = async () => {
	const feedbackQuestions = await dbFeedback.getSessionFeedbackQuestions();
	return feedbackQuestions || {};
};
